import clsx from 'clsx';
import React, { useCallback } from 'react';
import toast from 'react-hot-toast';

import { useConnectWithNotifications } from '../../../hooks/use-connect-with-notifications';
import styles from '../styles.module.css';

interface Props {
  isOpen: boolean;
  onBeforeClick?: () => void;
}

export const ConnectButton = ({ isOpen, onBeforeClick }: Props) => {
  const { openConnectModal } = useConnectWithNotifications();

  const handleClick = useCallback(async () => {
    onBeforeClick?.();

    try {
      openConnectModal();
    } catch (e) {
      toast.error('User rejected wallet connect');
    }
  }, [openConnectModal, onBeforeClick]);

  const cn = clsx(styles.connectButton, !isOpen && styles.connectButtonSM);

  return (
    <button type="button" onClick={handleClick} className={cn}>
      {isOpen ? 'Connect Wallet' : '+'}
    </button>
  );
};
